/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { platformResellerConstants } from './actions';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import Filter from '../../interfaces/forms/Filter';

const _ = require('underscore');

export type LoadPlatformResellersType = {
    callback: () => void;
    filters: Array<Filter>;
};

export class PlatformResellerLoader {
    private itemLoaders: ItemLoaders;

    private plaformResellers: Array<PlatformResellerInterface>;

    private _platformResellerCollection: PlatformResellerCollectionInterface | null;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
        this.plaformResellers = [];
        this._platformResellerCollection = null;
    }

    loadPlatformResellerById = (
        platformResellerId: number,
        callback: (platformReseller: PlatformResellerInterface) => void,
        options = { propagateDataToCallback: true, dispatchAfterCallback: false }
    ): void => {
        this.itemLoaders.getWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers/' + platformResellerId)),
            'platform_reseller_item_loaders_get_loadPlatformResellerById',
            (data: PlatformResellerInterface): void => {
                callback(data);
            },
            options
        );
    };

    getPlatformResellerIdFromUri = (uri: string): number | null => {
        const match = uri.match(/\d+/);
        if (match) {
            return parseInt(match[0]);
        }
        return null;
    };

    getPlatformResellerNameByUri = (resellerUri: string): string | null => {
        const partnerId = this.getPlatformResellerIdFromUri(resellerUri);
        if (partnerId) {
            const partner = this.getPlatformResellerById(partnerId);
            if (partner) {
                return partner.mainname;
            }
        }
        return null;
    };

    loadPlatformResellers = (params: LoadPlatformResellersType): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
            platformResellerConstants.PLATFORM_RESELLER_LIST,
            params.filters,
            [{ name: 'mainname', value: 'asc' }],
            (data: PlatformResellerCollectionInterface): void => {
                this._platformResellerCollection = data;
                const items = new Array<HeaderCheckBoxSelectListElement>();
                if (data['hydra:totalItems'] && data['hydra:totalItems'] > 0) {
                    data['hydra:member']?.map((item: PlatformResellerInterface) => {
                        this.plaformResellers.push(item);
                    });
                    params.callback();
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    getPlatformResellersHeaderList = (): Array<HeaderCheckBoxSelectListElement> => {
        const items = new Array<HeaderCheckBoxSelectListElement>();
        this.plaformResellers.map((item: PlatformResellerInterface) => {
            items.push({ name: item.mainname, value: item.id });
        });
        return items;
    };

    getPlatformResellerById = (platformResellerId: number): PlatformResellerInterface | null => {
        return _.find(this.plaformResellers, (item: PlatformResellerInterface) => {
            return item.id === platformResellerId;
        });
    };

    getPlatformResellersList = (): Array<PlatformResellerInterface> => {
        return this.plaformResellers;
    };

    updateFilterRptSearch = (filters: Array<Filter>, type?: string): Array<Filter> => {
        const newValue: Array<string> = [];
        if (!type) {
            type = 'recipient';
        }
        filters.map((item: Filter) => {
            if (item.name === type) {
                if (Array.isArray(item.value)) {
                    for (let i = 0; i < item.value.length; i++) {
                        const reseller = this.getPlatformResellerById(parseInt(item.value[i].toString()));
                        if (reseller && reseller.rpt) {
                            newValue.push(reseller.rpt);
                        }
                    }
                }
                item.value = newValue;
            }
        });
        return filters;
    };

    getPlatformResellerCollection = (): PlatformResellerCollectionInterface | null => {
        return this._platformResellerCollection;
    };

    setPlatformResellerCollection = (value: PlatformResellerCollectionInterface | null): void => {
        this._platformResellerCollection = value;
    };
}
